import { render } from "./XmlMappingHeadForm.vue?vue&type=template&id=19576a0d&ts=true"
import script from "./XmlMappingHeadForm.vue?vue&type=script&lang=ts"
export * from "./XmlMappingHeadForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__